import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TopicVector extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            expanded: false,
            disp_vec: null
        }
    }

    componentWillMount() {
        if (this.props.vector) {
            if ('ids' in this.props.vector && 'weights' in this.props.vector) {
                var ids = this.props.vector['ids'];
                var weights = this.props.vector['weights'];
                if (ids.length === weights.length) {
                    // pull out the ids and weights so we can sort them by weight
                    let vec = [];
                    for (var i=0; i < ids.length; i++) {
                        vec.push({'id': ids[i], 'weight': weights[i]})
                    }
                    // sort the array 
                    vec.sort(function(a, b) {
                        return ((a.weight > b.weight) ? -1 : ((a.weight == b.weight) ? 0 : 1));
                    });
                    // update the state
                    this.setState({
                        disp_vec: vec
                    })
                } else {
                    console.log('TopicVector length of ids and weights array are not same!');
                }
            }
        }
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return(
            <div>
            {(this.props.vector && this.state.disp_vec) &&
                <div>
                    <h2 className="group-title" onClick={ this.toggle }>
                        topic vector (<span className='results-count'>{ this.state.disp_vec.length }</span>)
                        <span className={toggleClasses}/>
                    </h2>

                    <div className={ this.state.expanded ? 'group-body indent-body expanded' : 'group-body indent-body' }>
                    {
                        this.state.disp_vec.map(function(vec, idx) {
                            return (<div key={idx}>
                                <span className="topic-vector-id">{vec.id}</span>
                                <span> : </span>
                                <span>{vec.weight.toFixed(4)}</span>
                            </div>)
                        })                      
                    }
                    </div>
                </div>
            }
            </div>
        );
    }
};

TopicVector.propTypes = {
};

export default TopicVector;

